// extracted by mini-css-extract-plugin
module.exports = {"root":"_2wk38","itemClickWrapper":"_1drLQ","imageZoomBtn":"_1gQB6","sizer":"_1jy5f","imageWrapper":"_3IXcF","imageBorder":"_3CWkv","image":"_2r0F8","overlay":"_2z-8d"};